import {
  FieldValues,
  Path,
  RegisterOptions,
  useFormContext,
} from 'react-hook-form';
import { FormErrorLabel } from './FormErrorLabel';

export function selectError(error: boolean) {
  return error ? 'select-error' : '';
}

export function inputError(error: boolean) {
  return error ? 'input-error' : '';
}

export function FormControl<T extends FieldValues = FieldValues>({
  options,
  field,
  label,
  placeholder,
  type,
  readOnly,
}: {
  options?: RegisterOptions<T, Path<T>>;
  field: Path<T>;
  label: string | React.ReactNode;
  placeholder?: string;
  type: string;
  readOnly?: boolean;
}) {
  const form = useFormContext<T>();
  const err = form.formState.errors[field];

  return (
    <fieldset className="fieldset mb-2 max-w-xl">
      <legend className="fieldset-legend">{label}</legend>
      <input
        type={type}
        className={`input input-bordered w-full ${inputError(!!err)}`}
        placeholder={placeholder}
        disabled={form.formState.isSubmitting}
        aria-disabled={form.formState.isSubmitting}
        aria-invalid={err ? 'true' : 'false'}
        aria-readonly={readOnly}
        readOnly={readOnly}
        {...form.register(field, options)}
      />
      <FormErrorLabel name={field} />
    </fieldset>
  );
}
